// import Vuetify from '@/plugins/vuetify'

const i18n = {
  state: {
    language: 'zhHant-HK', // Language Code for Vuetify i18n Module
    socket_language: null // Language name
  },
  mutations: {
    SET_I18N_LANGUAGE(state, language) {
      state.socket_language = language
      switch (language) {
        case 'cantonese':
          state.language = 'zhHant-HK'
          // Vuetify.current = 'zhHant-HK'
          break
        case 'mandarin':
          state.language = 'zhHant'
          // Vuetify.current = 'zhHant'
          break
        case 'putonghua':
          state.language = 'zhHans'
          // Vuetify.current = 'zhHans'
          break
        case 'english':
          state.language = 'en'
          // Vuetify.current = 'en'
          break
        case 'japanese':
          state.language = 'ja'
          // Vuetify.framework.lang.current = 'ja'
          break
        case 'korean':
          state.language = 'ko'
          // Vuetify.framework.lang.current = 'ko'
          break
      }
    }
  }
}

export default i18n
